import { Thumbnail } from '@osmosis/shared/types/learndb/learnData';
import { getBestThumb } from '@osmosis/shared/video';
import { useDeviceType } from '../context/DeviceTypeProvider';

/**
 * Hook to get the best video thumbnail based on device.
 */
export const useVideoThumbnail = (data?: Thumbnail) => {
  const { isMobile } = useDeviceType();
  return getBestThumb(data, isMobile);
};
